import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        callingAPI: true,
        searching: "",
        alert_success: false,
        alert_error: false,
        alert_message: '',
        // serverURI: "http://localhost:8000",
        serverURI: "https://boletowebapi.credipremium.com.br",
        s3URI: "https://s3.sa-east-1.amazonaws.com/assets.premium.com.br",
        user: null,
        token: null,
        userInfo: {
            messages: [{ 1: "test", 2: "test" }],
            notifications: [],
            tasks: []
        }
    },
    mutations: {
        TOGGLE_LOADING(state) {
            state.callingAPI = !state.callingAPI;
        },
        TOGGLE_SEARCHING(state) {
            state.searching = state.searching === "" ? "loading" : "";
        },
        SET_ALERT_MESSAGE(state, message) {
            state.alert_message = message;
        },
        SHOW_ALERT_SUCCESS(state) {
            state.alert_success = true;
            setTimeout(function() {
                state.alert_success = false;
                state.alert_message = '';
            }, 3000);
        },
        SHOW_ALERT_ERROR(state) {
            state.alert_error = true;
            setTimeout(function() {
                state.alert_error = false;
                state.alert_message = '';
            }, 3000);
        },
        SET_USER(state, user) {
            state.user = user;
        },
        SET_TOKEN(state, token) {
            state.token = token;
        }
    },
    getters: {
        getHeader: state => {
            let header = {
                Accept: "application/json",
                withCredentials: true
            };
            return header;
        },
        getHeaderAuth: state => {
            let options = {
                headers: {
                    "Access-Control-Allow-Headers": [
                        "Origin",
                        "X-Requested-With",
                        "Content-Type",
                        "Accept"
                    ],
                    Authorization: "Bearer " + state.token
                },
                withCredentials: true
            };
            return options;
        }
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js